
export const AlignTextRight = ({color="#4E4B66", size=20}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8.33333H7.22222M15 5H5M15 11.6667H5M15 15H7.22222" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg> 
  );
}